// extracted by mini-css-extract-plugin
export default {"order":"b1_TLYzA","orderTitle":"BRKoydSq","actions":"yXzlLrHe"};